<template>
  <v-tooltip bottom>
    <v-carousel
      fill-height
      :height="height"
      hide-delimiters
      vertical
      :interval="10000"
      :cycle="cycle"
      class="elevation-15"
      :light="true"
      v-viewer
      @change="cycle=true"
      slot="activator"
    >
      <v-carousel-item :lazy="true" v-for="(item,i) in items" :key="i">
        <img
          :src="doc_url+item.urlImagen"
          width="100%"
          height="300px"
          @click.prevent="cycle=false"
          v-if="pantallaEsMobil()"
        />
        <v-card height="100%" class="pt-1" v-else>
          <v-card-text>
            <!-- Para noticias con contenido -->
            <v-layout row wrap v-if="item.tipo==1">
              <v-flex lg7 md6 sm12 xs12>
                <img
                  :src="doc_url+item.urlImagen"
                  :width="'100%'"
                  :height="imgWidth(item.altoImagen)"
                  @click.prevent="cycle=false"
                />
              </v-flex>
              <v-flex
                lg5
                md6
                sm12
                xs12
                :class="{'px-2': $vuetify.breakpoint.smAndDown, 'px-3': $vuetify.breakpoint.mdAndUp}"
                hidden-sm-and-down
              >
                <span class="title font-weight-bold">{{item.titulo}}</span>
                <p class="text-sm-justify text-xs-justify pt-3 mb" v-html="item.contenido"></p>
              </v-flex>
            </v-layout>
             <!-- Para noticias de solo imagen -->
            <v-layout row wrap v-else-if="item.tipo==2" justify-center>
              <v-flex xs12>
                <img
                  :src="doc_url+item.urlImagen"
                  :width="imgWidth(item.anchoImagen)"
                  :height="imgWidth(item.altoImagen)"
                  @click.prevent="cycle=false"
                />
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-carousel-item>
    </v-carousel>
    <span>
      <h4>haz click en la imagen para ampliar</h4>
    </span>
  </v-tooltip>
</template>
<script>
export default {
  data() {
    return{
        height: 700,
        cycle:true,
    }
  },
  computed: {
    items() {
      return this.$store.getters.noticias;
    },
    doc_url() {
      return this.$docUrl;
    }
  },
  mounted: function() {
    this.onResize();
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods:{
    pantallaEsMobil(){
      return (this.$vuetify.breakpoint.smAndDown)
    },
    imgWidth(anchoImagen){
      return (this.$vuetify.breakpoint.mdAndDown?'100%':anchoImagen);
    },
    imgHeigth(altoImagen){
      return (this.$vuetify.breakpoint.smAndDown?'100%':altoImagen)
    },
    onResize() {
      const width = this.$vuetify.breakpoint.width;
      if (width < 3680) {
        this.height = 450;
      }
      if (width < 1900) {
        this.height = 380;
      }
      if (width < 1264) {
        this.height = 380;
      }
      if (width < 960) {
        this.height = 350;
      }
      if (width < 600) {
        this.height = 300;
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Inicio/Carousel.vue